import { PathBuilder, routeManager } from '@lib/route-manager';
import {
  isRootFolder,
  serializeFolderTrailParams,
  SPACE_FOLDER_IDS_PARAM,
  SPACE_FOLDER_NAMES_PARAM,
} from './space-url.util';

const buildFormSpaceBasePath = (formId: string) =>
  routeManager.standard.testMaker.fullPath.form.edit.pathParams(formId).path;

export type FormEditUrlOptions = {
  folderId?: string | null;
  folderIds?: string[];
  folderNames?: string[];
};

const appendFolderTrail = (builder: PathBuilder, options?: FormEditUrlOptions) => {
  const folderId = options?.folderId;
  if (folderId && !isRootFolder({ id: folderId })) {
    builder.withQueryParam('folder', folderId);
  }

  const trailParams = serializeFolderTrailParams(options?.folderIds, options?.folderNames);
  if (trailParams) {
    builder.withQueryParam(SPACE_FOLDER_IDS_PARAM, trailParams.folderIds);
    builder.withQueryParam(SPACE_FOLDER_NAMES_PARAM, trailParams.folderNames);
  }
};

export function buildFormEditUrl(
  formId: string,
  formTitle: string,
  options?: FormEditUrlOptions,
) {
  const builder = new PathBuilder()
    .withBasePath(buildFormSpaceBasePath(formId))
    .withQueryParam('name', formTitle)
    .withQueryParam('level', '2');

  appendFolderTrail(builder, options);

  return builder.build();
}

export function buildFormPreviewUrl(
  formId: string,
  formTitle?: string,
  options?: FormEditUrlOptions,
) {
  const builder = new PathBuilder()
    .withBasePath(buildFormSpaceBasePath(formId))
    .withQueryParam('menu', 'review')
    .withQueryParam('level', '2');

  if (formTitle) {
    builder.withQueryParam('name', formTitle);
  }

  appendFolderTrail(builder, options);

  return builder.build();
}
